import React, { useEffect, useState, useCallback, useMemo } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Button, Modal } from "react-bootstrap";
import Card from "../../../components/Card";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import CreatePostNew from "../../../components/create-post-new";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { FaHeart, FaComment, FaShare, FaEllipsisH, FaReply, FaEye, FaEyeSlash, FaTrash } from "react-icons/fa";
import user1 from "../../../assets/images/user/users.png";
import swal from "sweetalert";
import ProfileHeader from "../../../components/profile-header";
import bg3 from "../../../assets/images/page-img/profile-bg3.jpg";
import {
  addMediaToInstagram,
  getIgstories,
  getPostComments,
  igProfile,
  insertPostComment,
  getCommentReplies,
  replyToComment,
  hideUnhideComment,
  toggleMediaComments,
  deleteComment
} from "../../../store/instagram/instagramThunk";
import { useDispatch, useSelector } from "react-redux";
import TimestampConverter from "../../../components/TimestampConverter";
import { Hourglass } from "react-loader-spinner";
import SharePostModel from "../../../components/sharePostModel/share-post-model";
import Stories from "../../../components/Stories";
import { uploadFileToCloudinary } from "../../../store/Cloudinary/CloudinaryThunk";
import { toast } from "react-toastify";
import { FaFileCirclePlus } from "react-icons/fa6";

// Initialize Fancybox for all images

const Igprofile = () => {
  const dispatch = useDispatch();
  const {
    profile,
    loading,
    error,
    Comments,
    igloading,
    Igstoriespanding,
    Igstorieserror,
    Igstoriessccsess,
  } = useSelector((state) => state.instagram);

  const { uploadStatus, uploadedFile, uploadError } = useSelector(
    (state) => state.cloudinary
  );

  // State management
  const [showComments, setShowComments] = useState({});
  const [showReplies, setShowReplies] = useState({});
  const [replyingTo, setReplyingTo] = useState(null);
  const [commentSettings, setCommentSettings] = useState({});
  const [hiddenComments, setHiddenComments] = useState(new Set());
  const [showShareModal, setShowShareModal] = useState(false);
  const [sharepost, setSharepost] = useState(null);
  const [Igstories, setIgstories] = useState(null);
  const [show, setShow] = useState(false);
  const [storiesInsert, setStoriesInsert] = useState(false);
  const [loadedComments, setLoadedComments] = useState(new Set());
  const [loadedReplies, setLoadedReplies] = useState(new Set());
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  const [apiLoading, setApiLoading] = useState({
    comments: {},
    replies: {},
    posting: false,
    deleting: false
  });

  // Validation schemas
  const validationSchema = useMemo(() =>
    Yup.object({
      commentText: Yup.string().trim().required("Comment cannot be empty"),
    }), []);

  const StoryvalidationSchema = useMemo(() =>
    Yup.object({
      file: Yup.mixed().required("File is required"),
    }), []);

  // Toggle comments visibility and load comments if not already loaded
  const toggleComments = useCallback(async (postId) => {
    const isVisible = showComments[postId];
    setShowComments((prevState) => ({
      ...prevState,
      [postId]: !isVisible,
    }));

    if (!isVisible && !loadedComments.has(postId)) {
      setApiLoading(prev => ({ ...prev, comments: { ...prev.comments, [postId]: true } }));
      try {
        const response = await dispatch(getPostComments(postId)).unwrap();
        if (response.success) {
          setLoadedComments(prev => new Set([...prev, postId]));
          // No need to set local state; Redux store's Comments should update
          console.log(`Comments for post ${postId} loaded:`, response);
        } else {
          throw new Error(response.message || "Failed to load comments");
        }
      } catch (error) {
        console.error('Failed to load comments:', error);
      } finally {
        setApiLoading(prev => ({ ...prev, comments: { ...prev.comments, [postId]: false } }));
      }
    }
  }, [dispatch, loadedComments, showComments]);

  // Toggle replies visibility and load replies if not already loaded
  const toggleReplies = useCallback(async (commentId) => {
    const isVisible = showReplies[commentId];
    setShowReplies((prevState) => ({
      ...prevState,
      [commentId]: !isVisible,
    }));

    if (!isVisible && !loadedReplies.has(commentId)) {
      setApiLoading(prev => ({ ...prev, replies: { ...prev.replies, [commentId]: true } }));
      try {
        const response = await dispatch(getCommentReplies(commentId)).unwrap();
        console.log(response, "responseresponseresponseresponse")
        if (response.success) {
          setLoadedReplies(prev => new Set([...prev, commentId]));
          setShowReplies(prev => ({ ...prev, [commentId]: response.replies }));
        }
      } catch (error) {
        console.error('Failed to load replies:', error);
        toast.error("Failed to load replies");
      } finally {
        setApiLoading(prev => ({ ...prev, replies: { ...prev.replies, [commentId]: false } }));
      }
    }
  }, [dispatch, showReplies, loadedReplies]);

  // Handle story creation
  const handleshowStory = useCallback(() => {
    setShow(true);
    setStoriesInsert(true);
  }, []);

  useEffect(() => {
    Fancybox.bind("[data-fancybox='gallery']", {
      Thumbs: { autoStart: false },
      Toolbar: {
        display: [
          { id: "counter", position: "left" },
          "zoomIn",
          "zoomOut",
          "fullscreen",
          "download",
          "close"
        ]
      },
      Images: {
        initialSize: "fit"
      }
    });

    return () => {
      Fancybox.unbind("[data-fancybox='gallery']");
      Fancybox.close();
    };
  }, []);


  const handleClose = useCallback(() => {
    setShow(false);
    setStoriesInsert(false);
  }, []);

  // Handle image lightbox
  const imageOnSlide = useCallback((number, item, carouselImages = null) => {
    // Prevent the default link behavior
    if (carouselImages && Array.isArray(carouselImages)) {
      const sources = carouselImages
        .map(child => child?.media_url)
        .filter(url => typeof url === 'string' && url)
        .map(url => ({ src: url, type: 'image' }));

      if (sources.length === 0) {
        toast.error("No valid images found in carousel");
        return;
      }

      Fancybox.show(sources, {
        startIndex: number || 0
      });
    } else if (item?.media_url && typeof item.media_url === 'string') {
      Fancybox.show([{ src: item.media_url, type: 'image' }]);
    } else {
      console.error("Invalid image URL");
      toast.error("Cannot open image: Invalid URL");
    }
  }, []);


  const handleAddComment = useCallback(async (postId, text, resetForm, isReply = false, parentCommentId = null) => {
    if (!text || !text.trim() || !postId) {
      toast.error("Comment text and post ID are required");
      return;
    }

    setApiLoading(prev => ({ ...prev, posting: true }));
    try {
      const data = { postId, message: text.trim() };
      const response = isReply
        ? await dispatch(replyToComment({ commentId: parentCommentId, message: text.trim() })).unwrap()
        : await dispatch(insertPostComment(data)).unwrap();

      if (response.status === "success") {
        // Create a temporary comment object for immediate display
        const newComment = {
          id: response.commentId || `temp-${Date.now()}`, // Use API-provided ID or temporary ID
          text: text.trim(),
          timestamp: new Date().toISOString(),
          from: {
            username: profile?.data?.username || "Current User",
            profile_picture_url: profile?.data?.profile_picture_url || ""
          },
          replies_count: 0,
          replies: isReply ? [] : undefined // Initialize replies array only for main comments
        };

        // Update Redux store directly for optimistic UI update
        dispatch({
          type: 'instagram/addCommentOptimistically',
          payload: {
            postId,
            comment: newComment,
            isReply,
            parentCommentId
          }
        });

        // Refresh comments from server to ensure consistency
        await dispatch(getPostComments(postId)).unwrap();
        resetForm();
        if (isReply) setReplyingTo(null);

        toast.success(response.message || `${isReply ? 'Reply' : 'Comment'} posted successfully!`);

      } else {
        throw new Error(response.message || `Failed to post ${isReply ? 'reply' : 'comment'}`);
      }
    } catch (error) {
      console.error('Error posting comment:', error);
      toast.error(error.message || `Failed to post ${isReply ? 'reply' : 'comment'}`);
      // Optionally revert the optimistic update on failure
      dispatch({
        type: 'instagram/revertComment',
        payload: { postId, commentId: `temp-${Date.now()}`, isReply, parentCommentId }
      });
    } finally {
      setApiLoading(prev => ({ ...prev, posting: false }));
    }
  }, [dispatch, profile, setReplyingTo]);
  // Hide/Unhide comment
  const toggleCommentVisibility = useCallback(async (commentId) => {
    const isHidden = hiddenComments.has(commentId);
    try {
      const response = await dispatch(hideUnhideComment({ commentId, hide: !isHidden })).unwrap();
      if (response.success) {
        setHiddenComments(prev => {
          const newSet = new Set(prev);
          if (isHidden) newSet.delete(commentId);
          else newSet.add(commentId);
          return newSet;
        });
        toast.success(response.message || `Comment ${isHidden ? 'unhidden' : 'hidden'} successfully!`);
      }
    } catch (error) {
      console.error('Error toggling comment visibility:', error);
      toast.error("Failed to update comment visibility");
    }
  }, [dispatch, hiddenComments]);

  // Delete comment
  const deleteCommentAction = useCallback(async (commentId, postId) => {
    console.log(commentId, postId, "commentId, postId");
    const result = await swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this comment!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (result) {
      setApiLoading(prev => ({ ...prev, deleting: true }));
      try {
        const response = await dispatch(deleteComment(commentId)).unwrap();
        if (response?.success) {
          toast.success(response.message || "Comment deleted successfully!");
          // Refresh comments via Redux to update store
          await dispatch(getPostComments(postId)).unwrap();
        }
      } catch (error) {
        console.error('Error deleting comment:', error);
        toast.error(error?.message || "Failed to delete comment");
      } finally {
        setApiLoading(prev => ({ ...prev, deleting: false }));
      }
    }
  }, [dispatch]);

  // Toggle comments on/off for post
  const togglePostComments = useCallback(async (postId) => {
    // Get current state - if undefined, assume comments are enabled (true)
    const currentState = commentSettings[postId]?.disabled ?? false;

    try {
      const response = await dispatch(toggleMediaComments({
        mediaId: postId,
        commentEnabled: !currentState // Toggle the current state
      })).unwrap();

      if (response.success) {
        setCommentSettings(prev => ({
          ...prev,
          [postId]: { disabled: !currentState },
        }));
        toast.success(response.message || `Comments ${!currentState ? 'disabled' : 'enabled'} successfully!`);
      }
    } catch (error) {
      console.error('Error toggling post comments:', error);
      toast.error("Failed to update comment settings");
    }
  }, [dispatch, commentSettings]);


  // Handle share functionality
  const handleShare = useCallback((post) => {
    setSharepost(post);
    setShowShareModal(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    setShowShareModal(false);
  }, []);

  // Handle story file submission
  // const Submitform = useCallback(async (values, { setSubmitting }) => {
  //   if (!values.file) {
  //     toast.error("Please select a file");
  //     return;
  //   }

  //   setSubmitting(true);
  //   try {
  //     const response = await dispatch(uploadFileToCloudinary(values.file)).unwrap();
  //     if (response) {
  //       toast.success("File uploaded successfully!");
  //     }
  //   } catch (error) {
  //     console.error('Upload error:', error);
  //     toast.error("Failed to upload file");
  //   } finally {
  //     setSubmitting(false);
  //   }
  // }, [dispatch]);

  const Submitform = useCallback((values) => {
    if (!values.file) {
      toast.error("Please select a file");
      return;
    }
    dispatch(uploadFileToCloudinary(values.file));
  }, [dispatch]);
  // Stories configuration
  const stories = useMemo(() => ({
    skin: "snapgram",
    autoFullScreen: true,
    stories: [
      {
        id: "1",
        photo: profile?.data?.profile_picture_url,
        name: "Your Story",
        items: Igstories,
      },
    ],
  }), [profile?.data?.profile_picture_url, Igstories]);

  const CommentItem = ({ comment, postId, isReply = false, depth = 0 }) => {
    const isHidden = hiddenComments.has(comment.id);
    const [showOptions, setShowOptions] = useState(false);
    const [showNestedReplies, setShowNestedReplies] = useState(false);

    return (
      <div className={`${isReply ? `ml-${Math.min(depth * 4, 16)} border-l-2 border-gray-200 pl-3` : ''} mb-4`}>
        <div className={`bg-white rounded-xl shadow-sm border hover:shadow-md transition-all duration-200 ${isHidden ? 'opacity-50' : ''}`}>
          <div className="p-4">
            <div className="flex items-start space-x-3">
              <img
                src={comment?.from?.profile_picture_url || user1}
                alt="user"
                className="w-10 h-10 rounded-full object-cover ring-2 ring-gray-200"
              />
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    <h6 className="font-semibold text-gray-900 text-sm">
                      {comment?.from?.username}
                    </h6>
                    <span className="text-xs text-gray-500">•</span>
                    <TimestampConverter timestamp={comment?.timestamp} />
                  </div>
                  {/* <div className="relative">
                    <button
                      onClick={() => setShowOptions(!showOptions)}
                      className="p-1 rounded-full hover:bg-gray-100 transition-colors"
                    >
                      <FaEllipsisH className="w-4 h-4 text-gray-400" />
                    </button>
                    {showOptions && (
                      <div className="absolute right-0 mt-1 w-48 bg-white rounded-lg shadow-lg border z-10">
                        <button
                          onClick={() => {
                            setReplyingTo(comment.id);
                            setShowOptions(false);
                          }}
                          className="w-full text-left px-4 py-2 text-sm hover:bg-gray-50 flex items-center space-x-2 text-gray-700"
                        >
                          <FaReply className="w-3 h-3" />
                          <span>Reply</span>
                        </button>
                        <button
                          onClick={() => {
                            toggleCommentVisibility(comment.id);
                            setShowOptions(false);
                          }}
                          className="w-full text-left px-4 py-2 text-sm hover:bg-gray-50 flex items-center space-x-2 text-gray-700"
                        >
                          {isHidden ? <FaEye className="w-3 h-3" /> : <FaEyeSlash className="w-3 h-3" />}
                          <span>{isHidden ? 'Unhide' : 'Hide'}</span>
                        </button>
                        <button
                          onClick={() => {
                            deleteCommentAction(comment.id, postId);
                            setShowOptions(false);
                          }}
                          className="w-full text-left px-4 py-2 text-sm hover:bg-red-50 text-red-600 flex items-center space-x-2"
                        >
                          <FaTrash className="w-3 h-3" />
                          <span>Delete</span>
                        </button>
                      </div>
                    )}
                  </div> */}
                </div>
                <p className="text-gray-800 text-sm mt-1 leading-relaxed">
                  {comment?.text}
                </p>
                {/* <div className="flex items-center space-x-4 mt-3">
                  <button className="flex items-center space-x-1 text-gray-500 hover:text-red-500 transition-colors">
                    <FaHeart className="w-4 h-4" />
                    <span className="text-xs">Like</span>
                  </button>
                  <button
                    onClick={() => setReplyingTo(comment.id)}
                    className="flex items-center space-x-1 text-gray-500 hover:text-[#50B5FF] transition-colors"
                  >
                    <FaReply className="w-4 h-4" />
                    <span className="text-xs">Reply</span>
                  </button>
                  {(comment.replies_count > 0 || (comment.replies && comment.replies.length > 0)) && (
                    <button
                      onClick={() => setShowNestedReplies(!showNestedReplies)}
                      className="text-xs text-[#50B5FF] hover:text-blue-600 transition-colors"
                    >
                      {showNestedReplies ? 'Hide' : 'View'} {comment.replies_count || comment.replies?.length || 0} replies
                    </button>
                  )}
                </div> */}
              </div>
            </div>
          </div>
        </div>

        {/* Reply Form */}
        {replyingTo === comment.id && (
          <div className="mt-3 ml-6 md:ml-8">
            <Formik
              initialValues={{ commentText: "" }}
              validationSchema={validationSchema}
              onSubmit={(values, { resetForm }) => {
                handleAddComment(postId, values.commentText, resetForm, true, comment.id);
              }}
            >
              {({ values, handleChange, handleSubmit, isSubmitting }) => (
                <Form onSubmit={handleSubmit}>
                  <div className="flex space-x-3">
                    <img
                      src={profile?.data?.profile_picture_url}
                      alt="your avatar"
                      className="w-8 h-8 rounded-full object-cover"
                    />
                    <div className="flex-1">
                      <Field
                        type="text"
                        name="commentText"
                        className="w-full px-4 py-2 border border-gray-200 rounded-full focus:outline-none focus:ring-2 focus:ring-[#50B5FF] focus:border-transparent"
                        placeholder={`Reply to ${comment?.from?.username}...`}
                        value={values.commentText || ""}
                        onChange={handleChange}
                      />
                      <div className="flex items-center justify-between mt-2">
                        <ErrorMessage
                          name="commentText"
                          component="div"
                          className="text-red-500 text-xs"
                        />
                        <div className="flex space-x-2">
                          <button
                            type="button"
                            onClick={() => setReplyingTo(null)}
                            className="px-3 py-1 text-xs text-gray-500 hover:text-gray-700 transition-colors"
                          >
                            Cancel
                          </button>
                          <button
                            type="submit"
                            disabled={isSubmitting || !values.commentText?.trim() || apiLoading.posting}
                            className="px-4 py-1 bg-[#50B5FF] text-white text-xs rounded-full hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                          >
                            {apiLoading.posting ? 'Posting...' : 'Reply'}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        )}

        {/* Nested Replies */}
        {showNestedReplies && comment.replies && comment.replies.length > 0 && (
          <div className="mt-4 space-y-3">
            {comment.replies.map((reply, index) => (
              <CommentItem
                key={reply.id || index}
                comment={reply}
                postId={postId}
                isReply={true}
                depth={depth + 1}
              />
            ))}
          </div>
        )}
      </div>
    );
  };

  // Memoized render function for post content
  const renderPostContent = useCallback((item) => {
    const commentItem = Comments.find((commenti) => commenti?.postId === item?.id);
    const commentsDisabled = commentSettings[item?.id]?.disabled;

    const PostHeader = () => (
      <div className="flex items-center justify-between p-4 border-b border-gray-100">
        <div className="flex items-center space-x-3">
          <img
            loading="lazy"
            className="w-12 h-12 rounded-full object-cover ring-2 ring-[#50B5FF] shadow-sm"
            src={profile?.data?.profile_picture_url}
            alt=""
          />
          <div>
            <h5 className="font-semibold text-gray-900 text-lg">
              {profile?.data?.username}
            </h5>
            <small className="flex items-center text-gray-500 text-sm">
              <span className="material-symbols-outlined text-sm mr-1">schedule</span>
              <TimestampConverter timestamp={item?.timestamp} />
            </small>
          </div>
        </div>
        <div className="relative">
          <button className="p-2 rounded-full hover:bg-gray-100 transition-colors">
            <FaEllipsisH className="w-5 h-5 text-gray-400" />
          </button>
        </div>
      </div>
    );

    const PostActions = () => (
      <div className="px-4 py-3 border-t border-b border-gray-100 bg-gray-50">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-6">
            {/* <button className="flex items-center space-x-2 text-gray-600 hover:text-red-500 transition-colors group">
              <FaHeart className="w-6 h-6 group-hover:scale-110 transition-transform" />
              <span className="text-sm font-medium">Like</span>
            </button> */}
            <button
              onClick={() => toggleComments(item?.id)}
              className="flex items-center space-x-2 text-gray-600 hover:text-[#50B5FF] transition-colors group"
              disabled={apiLoading.comments[item?.id]}
            >
              <FaComment className="w-6 h-6 group-hover:scale-110 transition-transform" />
              <span className="text-sm font-medium">
                {apiLoading.comments[item?.id] ? 'Loading...' : 'Comment'}
              </span>
            </button>
            <button
              onClick={() => handleShare(item)}
              className="flex items-center space-x-2 text-gray-600 hover:text-green-500 transition-colors group"
            >
              <FaShare className="w-6 h-6 group-hover:scale-110 transition-transform" />
              <span className="text-sm font-medium">Share</span>
            </button>
          </div>
          {/* <button
            onClick={() => togglePostComments(item?.id)}
            className={`text-xs px-4 py-2 rounded-full transition-colors font-medium flex items-center space-x-2 ${commentSettings[item?.id]?.disabled
              ? 'bg-red-100 text-red-600 hover:bg-red-200'
              : 'bg-green-100 text-green-600 hover:bg-green-200'
              }`}
          >
            <span className="material-symbols-outlined text-sm">
              {commentSettings[item?.id]?.disabled ? 'comments_disabled' : 'mode_comment'}
            </span>
            <span>
              {commentSettings[item?.id]?.disabled ? 'Enable Comments' : 'Disable Comments'}
            </span>
          </button> */}
        </div>
      </div>
    );

    const CommentsSection = () => (
      <div className="px-4 py-4">
        {!commentsDisabled && showComments[item?.id] && (
          <div className="space-y-4">
            {commentItem?.comments?.data?.length > 0 ? (
              <div className="space-y-3">
                {commentItem.comments.data.map((comment, index) => (
                  <CommentItem
                    key={comment?.id || index}
                    comment={comment}
                    postId={item?.id}
                  />
                ))}
              </div>
            ) : (
              <div className="text-center py-8 bg-gray-50 rounded-xl">
                <FaComment className="w-12 h-12 text-gray-300 mx-auto mb-3" />
                <p className="text-gray-500 text-sm">No comments yet. Be the first to comment!</p>
              </div>
            )}
          </div>
        )}
        {/* {!commentsDisabled && (
          <div className="mt-4 pt-4 border-t border-gray-100">
            <Formik
              initialValues={{ commentText: "" }}
              validationSchema={validationSchema}
              onSubmit={(values, { resetForm }) => {
                handleAddComment(item?.id, values.commentText, resetForm);
              }}
            >
              {({ values, handleChange, handleSubmit, isSubmitting }) => (
                <Form onSubmit={handleSubmit}>
                  <div className="flex space-x-3">
                    <img
                      src={profile?.data?.profile_picture_url}
                      alt="your avatar"
                      className="w-10 h-10 rounded-full object-cover ring-2 ring-[#50B5FF]"
                    />
                    <div className="flex-1">
                      <Field
                        type="text"
                        name="commentText"
                        className="w-full px-4 py-3 border border-gray-200 rounded-full focus:outline-none focus:ring-2 focus:ring-[#50B5FF] focus:border-transparent placeholder-gray-400 text-sm"
                        placeholder="Write a comment..."
                        value={values.commentText || ""}
                        onChange={handleChange}
                      />
                      <div className="flex items-center justify-between mt-2">
                        <ErrorMessage
                          name="commentText"
                          component="div"
                          className="text-red-500 text-xs"
                        />
                        <button
                          type="submit"
                          disabled={isSubmitting || !values.commentText?.trim() || apiLoading.posting}
                          className="px-6 py-2 bg-[#50B5FF] text-white text-sm font-medium rounded-full hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 hover:shadow-md"
                        >
                          {apiLoading.posting ? 'Posting...' : 'Post'}
                        </button>
                      </div>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        )}
        {commentsDisabled && (
          <div className="text-center py-4 text-gray-500 bg-gray-50 rounded-xl">
            <p className="text-sm">Comments are disabled for this post</p>
          </div>
        )} */}
      </div>
    );

    switch (item?.media_type) {
      case "IMAGE":
        return (
          <div key={item.id} className="bg-white rounded-2xl shadow-md border hover:shadow-lg transition-all duration-300 mb-6">
            <PostHeader />
            <div className="relative">
              {item?.media_url && typeof item.media_url === 'string' ? (
                <div
                  className="w-full block cursor-pointer"
                  onClick={(e) => {
                    e.preventDefault();
                    imageOnSlide(0, item);
                  }}
                >
                  <img
                    loading="lazy"
                    src={item.media_url}
                    alt="post"
                    className="w-full max-h-96 object-cover hover:opacity-90 transition-opacity duration-200"
                    onError={(e) => {
                      e.target.src = 'path/to/fallback-image.jpg';
                    }}
                  />
                </div>
              ) : (
                <div className="text-center py-4 text-gray-500 bg-gray-50 rounded-lg">
                  <p className="text-sm">Image not available</p>
                </div>
              )}
            </div>
            <PostActions />
            <CommentsSection />
          </div>
        );
      case "VIDEO":
        return (
          <div key={item.id} className="bg-white rounded-2xl shadow-md border hover:shadow-lg transition-all duration-300 mb-6">
            <PostHeader />
            <div className="relative aspect-video">
              <iframe
                title="video"
                className="w-full h-full rounded-lg"
                src={item?.media_url}
                allowFullScreen
              />
            </div>
            <PostActions />
            <CommentsSection />
          </div>
        );
      case "CAROUSEL_ALBUM":
        if (!item?.children?.data?.length) {
          return (
            <div key={item.id} className="bg-white rounded-2xl shadow-md border hover:shadow-lg transition-all duration-300 mb-6">
              <PostHeader />
              <div className="p-4 text-center text-gray-500">No carousel images available</div>
              <PostActions />
              <CommentsSection />
            </div>
          );
        }
        return (
          <div key={item.id} className="bg-white rounded-2xl shadow-md border hover:shadow-lg transition-all duration-300 mb-6">
            <PostHeader />
            <div className="p-4">
              <div className="grid grid-cols-2 gap-3 rounded-lg overflow-hidden">
                {item.children.data
                  .filter(childItem => childItem?.media_url && typeof childItem.media_url === 'string')
                  .map((childItem, index) => (
                    <div
                      key={childItem?.id || index}
                      className="aspect-square overflow-hidden rounded-lg shadow-sm hover:shadow-md transition-all duration-200 block cursor-pointer"
                      onClick={(e) => {
                        e.preventDefault();
                        imageOnSlide(index, childItem, item.children.data);
                      }}
                    >
                      <img
                        loading="lazy"
                        src={childItem.media_url}
                        className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                        alt={`carousel item ${index + 1}`}
                        onError={(e) => {
                          e.target.src = 'path/to/fallback-image.jpg';
                        }}
                      />
                    </div>
                  ))}
              </div>
            </div>
            <PostActions />
            <CommentsSection />
          </div>
        );
      default:
        return null;
    }
  }, [profile, Comments, showComments, showReplies, replyingTo, commentSettings, hiddenComments, validationSchema, toggleComments, toggleReplies, handleShare, handleAddComment, imageOnSlide, toggleCommentVisibility, deleteCommentAction, togglePostComments, apiLoading]);  // Effects
  useEffect(() => {
    document.body.classList.add("profile-2");
    return () => document.body.classList.remove("profile-2");
  }, []);

  // Initial data loading - only run once
  useEffect(() => {
    if (isInitialLoad) {
      const loadInitialData = async () => {
        try {
          // Fetch profile and stories
          const [profileResponse, storiesResponse] = await Promise.all([
            dispatch(igProfile()).unwrap(),
            dispatch(getIgstories()).unwrap()
          ]);
          console.log("Profile and stories loaded successfully");

          // Fetch comments for all posts after profile is loaded
          if (profileResponse?.success && profile?.data?.media?.data) {
            const postIds = profile.data.media.data.map(item => item.id);
            // Fetch comments for each post
            await Promise.all(
              postIds.map(postId =>
                dispatch(getPostComments(postId)).unwrap()
              )
            );
            console.log("Comments for all posts loaded successfully");
          }
        } catch (error) {
          console.error("Error loading initial data:", error);
        } finally {
          setIsInitialLoad(false);
        }
      };
      loadInitialData();
    }
  }, [dispatch, isInitialLoad, profile]); // Added profile to dependencies  // Format stories data
  useEffect(() => {
    if (Igstoriessccsess && Array.isArray(Igstoriessccsess)) {
      const formattedStories = Igstoriessccsess.map((item) => ({
        id: item?.id,
        type: item?.media_type === "VIDEO" ? "video" : "photo",
        src: item?.media_url,
      }));
      setIgstories(formattedStories);
    }
  }, [Igstoriessccsess]);

  // Handle cloudinary upload success
  useEffect(() => {
    const postToInstagram = async () => {
      if (storiesInsert && uploadedFile?.url) {
        const toastId = toast.loading("Uploading story to Instagram...");
        const data = {
          imageUrl: uploadedFile.url,
          media_type: "STORIES",
          type: "REELS",
        };
        try {
          const response = await dispatch(addMediaToInstagram(data)).unwrap();
          if (response.success) {
            toast.update(toastId, {
              render: response.message || "Story posted successfully!",
              type: "success",
              isLoading: false,
              autoClose: 3000,
            });
            setShow(false);
            setStoriesInsert(false);
            await dispatch(getIgstories()).unwrap();
          } else {
            throw new Error(response.message || "Failed to post story");
          }
        } catch (error) {
          toast.update(toastId, {
            render: error || "Failed to post story to Instagram.",
            type: "error",
            isLoading: false,
            autoClose: 3000,
          });
        }
      }
    };
    postToInstagram();
  }, []);

  // Loading state
  if (igloading || isInitialLoad) {
    return (
      <div className="flex justify-center items-center h-screen bg-gray-50">
        <Hourglass
          visible={true}
          height="40"
          width="40"
          ariaLabel="hourglass-loading"
          colors={["#50B5FF", "#50B5FF"]}
        />
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <div className="flex justify-center items-center h-[50vh] bg-gray-50">
        <div className="text-center p-6 bg-white rounded-xl shadow-md">
          <h4 className="text-xl font-semibold text-gray-800 mb-2">Error loading profile</h4>
          <p className="text-gray-600 mb-4">{error}</p>
          <Button
            onClick={() => window.location.reload()}
            className="bg-[#50B5FF] text-white px-6 py-2 rounded-full hover:bg-blue-600 transition-all duration-200"
          >
            Retry
          </Button>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="min-h-screen bg-gray-50">
        <div className="relative">
          <ProfileHeader title="Profile" img={bg3} />
        </div>

        <div id="content-page" className="pt-0 px-4 md:px-6 lg:px-8">
          <Row>
            <Col lg="12">
              <Card className="bg-white rounded-2xl shadow-md border p-4 md:p-6">
                <Row>
                  <Col lg="2" className="flex justify-center lg:justify-start">
                    {Igstories?.length > 0 ? (
                      <Stories storie={stories} />
                    ) : (
                      <div className="relative">
                        {/* <div onClick={handleshowStory} className="cursor-pointer"> */}
                        <div className="cursor-pointer">
                          <img
                            src={profile?.data?.profile_picture_url}
                            className="w-20 h-20 rounded-full object-cover border-4 border-[#50B5FF] shadow-sm my-10"
                            alt="Add Story"
                          />
                        </div>
                        {/* <div className="absolute top-[70%] left-14 text-[#50B5FF] text-2xl rounded-full bg-white shadow-md p-1">
                          <FaFileCirclePlus />
                        </div> */}
                      </div>
                    )}
                  </Col>
                  <Col lg="10">
                    <div className="flex flex-col md:flex-row justify-between items-start md:items-center">
                      <div className="mb-4 md:mb-0">
                        <h4 className="text-2xl font-bold text-gray-900">{profile?.data?.username}</h4>
                        <p className="text-gray-600 text-base">{profile?.data?.name}</p>
                      </div>
                    </div>
                    <Row className="mt-4">
                      <Col lg="4" className="mb-4 md:mb-0">
                        <div className="relative border-l-2 border-r-2 border-gray-200 px-4 py-2 text-center md:text-left">
                          <h6 className="text-sm font-semibold text-gray-700 mb-2">Followers</h6>
                          <span className="text-gray-800 font-medium">
                            {profile?.data?.followers_count} followers
                          </span>
                        </div>
                      </Col>
                      <Col lg="3" className="mb-4 md:mb-0">
                        <div className="relative border-l-2 border-r-2 border-gray-200 px-4 py-2 text-center md:text-left">
                          <h6 className="text-sm font-semibold text-gray-700 mb-2">Follows</h6>
                          <span className="text-gray-800 font-medium">
                            {profile?.data?.follows_count} follows
                          </span>
                        </div>
                      </Col>
                      <Col lg="4"></Col>
                    </Row>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col lg="4">
              <Card className="bg-white rounded-2xl shadow-md border mb-6">
                <div className="p-4 border-b border-gray-100 flex justify-between items-center">
                  <h4 className="text-xl font-semibold text-gray-900">Bio</h4>
                  <Link to="#" className="text-[#50B5FF] text-sm hover:underline">
                    Know More
                  </Link>
                </div>
                <div className="p-4">
                  <div className="flex flex-col space-y-2">
                    {profile?.data?.biography?.split("\n")?.map((item, index) => (
                      <h6 key={index} className="text-gray-700 text-sm leading-relaxed">{item}</h6>
                    ))}
                  </div>
                </div>
              </Card>

              <div className="mb-0 md:mb-6">
                <Card className="bg-white rounded-2xl shadow-md border mb-6">
                  <div className="p-4 border-b border-gray-100 flex justify-between items-center">
                    <h4 className="text-xl font-semibold text-gray-900">Photos</h4>
                    <Link
                      to="#"
                      className="text-[#50B5FF] text-sm hover:underline"
                      onClick={(e) => {
                        e.preventDefault();
                        const allImages = profile?.data?.media?.data
                          ?.filter(img => img?.media_type === "IMAGE" && img?.media_url && typeof img.media_url === "string")
                          ?.map(img => ({ src: img.media_url, type: 'image' }));

                        if (allImages && allImages.length > 0) {
                          Fancybox.show(allImages, {
                            startIndex: 0
                          });
                        }
                      }}
                    >
                      See all photos
                    </Link>
                  </div>
                  <div className="p-4">
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-2 gap-2">
                      {profile?.data?.media?.data
                        ?.filter(item => item?.media_type === "IMAGE" && item?.media_url && typeof item.media_url === "string")
                        ?.slice(0, 5)
                        ?.map((item, index) => {
                          // Get all images for the gallery
                          const allImages = profile?.data?.media?.data
                            ?.filter(img => img?.media_type === "IMAGE" && img?.media_url && typeof img.media_url === "string")
                            ?.map(img => ({ src: img.media_url, type: 'image' }));

                          return (
                            <div
                              key={item?.id || index}
                              className="block cursor-pointer"
                              onClick={(e) => {
                                e.preventDefault();
                                // Open gallery starting from the clicked image
                                Fancybox.show(allImages, {
                                  startIndex: index
                                });
                              }}
                            >
                              <img
                                loading="lazy"
                                src={item.media_url}
                                alt="gallery"
                                className="w-full max-h-32 object-cover rounded-lg hover:scale-105 transition-transform duration-300 shadow-sm"
                                onError={(e) => {
                                  e.target.src = 'path/to/fallback-image.jpg';
                                }}
                              />
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </Card>

                <Card className="bg-white rounded-2xl shadow-md border">
                  <div className="p-4 border-b border-gray-100 flex justify-between items-center">
                    <h4 className="text-xl font-semibold text-gray-900">Videos</h4>
                    <Link to="#" className="text-[#50B5FF] text-sm hover:underline">
                      See all videos
                    </Link>
                  </div>
                  <div className="p-4">
                    <div className="grid gap-4">
                      {profile?.data?.media?.data
                        ?.filter(item => item?.media_type === "VIDEO")
                        ?.map((item, index) => (
                          <Link key={item?.id || index} to="#" className="block aspect-video">
                            <iframe
                              title="myFrame"
                              className="w-full h-full rounded-lg shadow-sm"
                              src={item?.media_url}
                              allowFullScreen
                            />
                          </Link>
                        ))}
                    </div>
                  </div>
                </Card>
              </div>
            </Col>

            <Col lg="8">
              {/* <CreatePostNew
                type="instagram"
                userImage={profile?.data?.profile_picture_url}
                handleshowStory={handleshowStory}
                className="bg-white rounded-2xl shadow-md border p-4 mb-6"
              /> */}
              <SharePostModel
                type="instagram"
                sharepost={sharepost}
                show={showShareModal}
                hide={handleCloseModal}
              />
              {profile?.data?.media?.data?.map((item) => renderPostContent(item))}
            </Col>
          </Row>
        </div>

        {/* Story Upload Modal */}
        <Modal
          show={show}
          onHide={handleClose}
          size="lg"
          centered
          fullscreen="sm-down"
          id="custom-post-modal"
        >
          <div className="flex justify-between items-center p-4 border-b border-gray-200 bg-white">
            <h5 className="text-xl font-semibold text-gray-900">Add Story </h5>
            <Link to="#" onClick={handleClose} className="text-gray-500 hover:text-gray-700">
              <span className="material-symbols-outlined">close</span>
            </Link>
          </div>
          <Modal.Body className="p-6">
            <div className="flex items-center space-x-4">
              <div className="user-img">
                <img
                  src={profile?.data?.profile_picture_url}
                  alt="Instagram Platform"
                  className="w-12 h-12 rounded-full object-cover ring-2 ring-[#50B5FF]"
                />
              </div>
              <Formik
                initialValues={{ file: null }}
                validationSchema={StoryvalidationSchema}
                onSubmit={Submitform}
              >
                {({ setFieldValue }) => (
                  <Form className="flex-1 space-y-4">
                    <div>
                      <h6 className="text-base font-semibold text-gray-800 mb-2">Photo/Video </h6>
                      <input
                        type="file"
                        name="file"
                        className="w-full p-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#50B5FF] file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:bg-[#50B5FF] file:text-white file:cursor-pointer "
                        accept="image/*,video/*"
                        onChange={(event) => setFieldValue("file", event.currentTarget.files[0])}
                      />
                      <ErrorMessage
                        name="file"
                        component="div"
                        className="text-red-500 text-xs mt-1"
                      />
                    </div>
                    <Button
                      variant="primary"
                      type="submit"
                      className="w-full bg-[#50B5FF] text-white py-3 rounded-full transition-all duration-200 hover:shadow-2xl hover:scale-[1.02] active:scale-[0.98] font-medium"
                    >
                      Publish story
                    </Button>
                  </Form>
                )}
              </Formik>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default Igprofile;